export default __webpack_public_path__ + "static/media/ic-art-partners.510e0bf6.svg";